import Icon from './Icon';
import { toggleTheme, useTheme } from '@/lib/theme';

// Light/dark flip — one round icon button in the top bar. Shows the
// theme you'd switch TO. Settings has the full Light / Dark / System
// choice. Hidden in the Mac app (`.mac-app .theme-toggle`), which
// follows the system appearance.
export default function ThemeToggle() {
  const dark = useTheme() === 'dark';
  return (
    <button
      type="button"
      onClick={toggleTheme}
      aria-label={dark ? 'Switch to light mode' : 'Switch to dark mode'}
      title={dark ? 'Light mode' : 'Dark mode'}
      className="icon-btn is-plain theme-toggle"
    >
      <Icon name={dark ? 'sun' : 'moon'} size={19} />
    </button>
  );
}
